export default __webpack_public_path__ + "static/22_18-7ed93b4b7e5d558b41acf6046759c311.png";